<template>
  <div>
    <page-title value="クラス日誌"></page-title>
    <date-pager class="pt-4"></date-pager>

    <div class="pt-10">
      <div>クラスを選択</div>
      <class-list :items="classList" @click="clickClass"></class-list>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/atoms/PageTitle.vue";
import DatePager from "@/components/atoms/DatePager.vue";
import ClassList from "@/components/molecules/ClassList.vue";
import { classModule } from "@/store/dataModules/classModule";
import LocalDataService from "@/service/LocalDataService";

export default defineComponent({
  name: "ClassReport",

  components: {
    PageTitle,
    DatePager,
    ClassList,
  },

  mounted() {
    this.listClass();
  },

  computed: {
    classList: function () {
      return classModule.classes;
    },
  },

  methods: {
    async listClass() {
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await classModule.listClass({
          nurseryId: nurseryId,
        });
      }
    },
    clickClass(id: string) {
      this.$router.push({ path: `/dailyreport/class/${id}` });
    },
  },
});
</script>
